<div class="center">
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<div class="container">

  <div *ngIf="token !== undefined; else nonconfirm">

    <div *ngIf="showForgotForm" class="pb-2 pt-2">
      <div class="row">
        <div class="col-6">
          <h2> Set New Password</h2>
        </div>
      </div>
      <div class="row">
        <div class="offset col-md-5">
          To change your account password, please enter the requested information below.
        </div>
      </div>
      <form #forgotPasswordForm="ngForm" class="offset-1 ">
        <div class="row">
          <div class=" justify-content-center ps-5 pe-5 pt-3">
            <span class="required">User ID: </span> <span class="ms-2"><b>{{userId}}</b></span>
          </div>
        </div>
        <div class="row">
          <div class="col-5 ps-0">
            <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
              <label for="password" class="required">New Password</label>
              <input appPassword [(ngModel)]="model.newPassword" id="password" name="password" class="form-control" #password="ngModel" appNoLeadingTrailingSpaces autocomplete="new-password"
                [maxlength]="MaxLen.Password" placeholder="New Password" minlength="8" pattern=".*[!@#$^_.,].*" (input)="confirmpassword.control.updateValueAndValidity()"
                required />
            </div>
            <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
              <label for="confirmpassword" class="required">Confirm Password</label>
              <input appPassword [(ngModel)]="dummy.password" class="form-control" class="form-control" autocomplete="new-password" [maxlength]="MaxLen.Password"
                [appExactMatch]="password" id="confirmpassword" name="confirmpassword" #confirmpassword="ngModel" placeholder="Confirm Password" (focus)="focusConfirmPassword()"
                (blur)="blurConfirmPassword()" required />
            </div>
          </div>
          <div *ngIf="password.dirty" class=" col-4 ps-0 mb-3 justify-content-center ps-5 pe-5 pt-3 password-panel">
            <ng-template [ngIf]="password.invalid || !confirmPasswordFocused">
              <div [ngClass]="password.errors?.noLeadingTrailingSpaces ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.noLeadingTrailingSpaces ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Cannot contain spaces at the beginning or end
              </div>
              <div [ngClass]="password.errors?.minlength || password.errors?.required ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.minlength || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Be at least 8 characters
              </div>
              <div [ngClass]="password.errors?.pattern || password.errors?.required ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.pattern || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Contain at least one of the following: ! &#64; # $ ^ _ . or ,
              </div>
            </ng-template>
            <ng-template [ngIf]="password.valid && confirmPasswordFocused">
              <div [ngClass]="confirmpassword.valid ? 'passed' : 'failed'">
                <i [ngClass]="confirmpassword.valid ? 'fa fa-circle-check' : 'fa fa-circle-xmark'"></i>
                Match the Password
              </div>
            </ng-template>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 ps-5 pe-5 pt-3 ">
            <button [disabled]="forgotPasswordForm.invalid" type="button" class="btn btn-primary px-4 mb-2" (click)="submitPassword()">Set Password</button>
            <app-help-link-icon [helpPath]="'SetNewPassword'" [customClass]="'ms-1 align-top float-end'"></app-help-link-icon>
          </div>
        </div>

      </form>

    </div>

    <div *ngIf="showNoUserForm" class="pb-2 pt-2">
      <div class="col-6">
        <h2> Create My Credentials</h2>
      </div>
      <div class="col-md-12">
        <div>
          Welcome to the Short Code Registry. <br> Please use this screen to create your User ID and password.
        </div>
      </div>
      <form #createCredentialsForm="ngForm">
        <div class="row">
          <div class="col-5">
            <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
              <label for="userId" class="required">User ID</label>
              <input appScrText mask="A*" [appCheckClash]="checkUsername(username)" (keydown)="userIdKeydown()" [(ngModel)]="model.userName" name="username" id="username"
                #username="ngModel" placeholder="User ID" minlength="6" required autocomplete="no" />
            </div>
            <div *ngIf="username.dirty" class="error-msg justify-content-center ps-5 pe-5 pt-1">
              <ng-template [ngIf]="username.errors">
                <div style="display: inline-block;" *ngIf="username.errors.minlength || username.errors.required ? 'failed' : 'passed' && !username.errors.clash">
                  <span [ngClass]="username.errors.minlength || username.errors.required ? 'failed' : 'passed'">
                    <i [ngClass]="username.errors.minlength || username.errors.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                    Be at least 6 characters
                  </span>
                </div>
                <span *ngIf="username.errors?.clash" class="failed">
                  <i class="fa fa-circle-xmark"></i>
                  This User ID is already in use
                </span>
                <span *ngIf="username.errors?.lockedOut" class="failed">
                  <i class="fa fa-circle-xmark"></i>
                  Too many failed attempts on the User ID field. Please wait.
                </span>
              </ng-template>

              <ng-template [ngIf]="isIdAvailable">
                <span class="passed">
                  <i class="fa fa-circle-check"></i>
                  This User ID is available
                </span>
              </ng-template>
              <ng-template [ngIf]="showSpinner">
                <i class="ms-3 fa fa-spin fa-spinner"></i>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
              <label for="password" class="required">Password</label>
              <input appPassword [(ngModel)]="model.newPassword" id="password" name="password" class="form-control" #password="ngModel" placeholder="Password" minlength="8"
                appNoLeadingTrailingSpaces pattern=".*[!@#$^_.,].*" (input)="confirmpassword.control.updateValueAndValidity()" required autocomplete="no" />
            </div>
            <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
              <label for="confirmpassword" class="required">Confirm Password</label>
              <input appPassword [(ngModel)]="dummy.password" class="form-control" class="form-control" [appExactMatch]="password" id="confirmpassword" name="confirmpassword" #confirmpassword="ngModel"
                placeholder="Confirm Password" (focus)="focusConfirmPassword()" (blur)="blurConfirmPassword()" required autocomplete="no" />
            </div>
          </div>
          <div *ngIf="password.dirty" class=" col-4 mb-3 justify-content-center ps-5 pe-5 pt-3 password-panel">
            <ng-template [ngIf]="password.invalid || !confirmPasswordFocused">
              <div [ngClass]="password.errors?.noLeadingTrailingSpaces || password.errors?.required ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.noLeadingTrailingSpaces || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Cannot contain spaces at the beginning or end
              </div>
              <div [ngClass]="password.errors?.minlength || password.errors?.required ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.minlength || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Be at least 8 characters
              </div>
              <div [ngClass]="password.errors?.pattern || password.errors?.required ? 'failed' : 'passed'">
                <i [ngClass]="password.errors?.pattern || password.errors?.required ? 'fa fa-circle-xmark' : 'fa fa-circle-check'"></i>
                Contain at least one of the following: ! &#64; # $ ^ _ . or ,
              </div>
            </ng-template>
            <ng-template [ngIf]="password.valid && confirmPasswordFocused">
              <div [ngClass]="confirmpassword.valid ? 'passed' : 'failed'">
                <i [ngClass]="confirmpassword.valid ? 'fa fa-circle-check' : 'fa fa-circle-xmark'"></i>
                Match the Password
              </div>
            </ng-template>
          </div>
        </div>
        <div class="mb-3 ps-5 pe-5 pt-3">
          <button [disabled]="createCredentialsForm.invalid || username.disabled" type="button" class="btn btn-primary px-4 mb-2" (click)="submitCredentials()">Create
            Credentials</button>
        </div>
      </form>
    </div>

  </div>
  <ng-template #nonconfirm>
    <div class="pb-2 pt-2">
      <div class="row">
        <div class="col-6">
          <h2 *ngIf="!submitted"> Forgot Password</h2>
          <h2 *ngIf="submitted">Password Reset Confirmation</h2>
        </div>
      </div>
      <div *ngIf="!submitted" class="row">
        <div class="offset col-md-4">
          The system will generate a temporary URL for you to use to reset your password
          and send it to the CSC Registrant email address on record.
        </div>

        <form #forgotPasswordForm="ngForm" (ngSubmit)="submit()" class="offset-1 col-4">
          <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
            <label for="useridoremail" class="required" i18n id="useridoremailLabel">User ID or Email</label>
            <input appScrText id="useridoremail" name="useridoremail" required class="form-control" placeholder="User ID or Email" [(ngModel)]="userIdOrEmail"
              #useridoremail="ngModel" autocomplete="username" autocomplete="no" />
            <app-error-msg [field]="useridoremail"></app-error-msg>
          </div>
          <div class="mb-3 justify-content-center mt-4 d-flex">
            <button [disabled]="forgotPasswordForm.invalid" type="submit" class="btn btn-primary px-4 mb-2">Reset
              Password</button>
            <app-help-link-icon [helpPath]="'ForgotPassword'" [customClass]="'ms-1 align-top float-end'"></app-help-link-icon>
          </div>
          <div class="mb-3 justify-content-center mt-4 d-flex">
            <a [routerLink]="'/sec/forgotusername'" class="pt-2 link color-blue" i18n id="forgotUserIdLink">Forgot User ID</a>
          </div>
          <hr />
        </form>
        <div class="mb-3 justify-content-center mt-4 mb-4 d-flex offset-4 col-6">
          If you need help please contact&nbsp;<a class="" href="{{customerSupportLink}}">Customer Support</a>
        </div>
      </div>
      <div *ngIf="submitted" class="row">
        <div class="col-5 mx-auto">
          <p>
            If you entered a valid User ID then a temporary url has been sent to the CSC Registrant email address on record.
            Please follow the directions in the email.
          <p>
            If you do not receive an email within a few minutes (either because of an incorrect User ID or
            invalid/out-of-date email address on record) then please contact
            <a href="{{customerSupportLink}}">Customer Support</a>.

        </div>
      </div>
    </div>

  </ng-template>
</div>